/* 
Hala May Mumu

Samples produced by Sam Zabala using Alchemy and Multi Sampler Software Instruments from Garageband / Logic Pro
Not for redistribution, resale or reuse
*/

import C0 from '/sounds/luhmimumu/C0.mp3'
import F0 from '/sounds/luhmimumu/F0.mp3'
import C2 from '/sounds/luhmimumu/C2.mp3'
import F2 from '/sounds/luhmimumu/F2.mp3'
import C4 from '/sounds/luhmimumu/C4.mp3'
import F4 from '/sounds/luhmimumu/F4.mp3'
import C6 from '/sounds/luhmimumu/C6.mp3'
import F6 from '/sounds/luhmimumu/F6.mp3'
import C8 from '/sounds/luhmimumu/C8.mp3'
import F8 from '/sounds/luhmimumu/F8.mp3'

export default {
	C0,
	F0,
	C2,
	F2,
	C4,
	F4,
	C6,
	F6,
	C8,
	F8,
}
